import React from 'react';

import classes from './ModuleCurriculumTab.module.css';
import { connect } from 'react-redux';
import * as actionCreators from '../../../../store/actions/mainLayoutActions';
import ResourceAPIController from '../../../../webServices/ResourceAPIController';
import { GetFromLocalStorage, IsListEmpty, IsObjectEmpty, IsStringEmpty, parseQueryParams, Log } from '../../../../utilities/CommonMethods';
import ShowLoader from '../../../../hoc/ShowLoader/ShowLoader';
import SessionPlanData from '../../../ModulesPageSections/SessionPlanData/SessionPlanData';
import CurriculumQuizContent from '../../../ModulesPageSections/CurriculumQuizContent/CurriculumQuizContent';
import { Redirect, withRouter } from 'react-router';
import CurriculumAssignmentContent from '../../../ModulesPageSections/CurriculumAssignmentContent/CurriculumAssignmentContent';
import EditAssignmentForm from '../../../Forms/CreateNewAssignmentForm/CreateNewAssignmentForm';
import EditQuizForm from '../../../Forms/CreateNewQuizForm/CreateNewQuizForm';
import SessionPlanForm from '../../../Forms/SessionPlanForm/SessionPlanForm';
import RouteEndPoints from '../../../../utilities/RouteEndPoints';
import AddMetaTags from '../../../AddMetaTags/AddMetaTags';
import Constants from '../../../../utilities/Constants';
import { getFullDateTime, parseDateWithWeekDay } from '../../../../utilities/DateTimeUtils';
import ModuleDetailsSidebar from '../../../ModuleDetailsSidebar/ModuleDetailsSidebar';
import ProgramProgressTopbarPM from '../../ProgramDetailsTopbar/ProgramDetailsTopbar';
import ProgressCard from '../../../UI/ProgressCard/ProgressCard';
import TodaysPlanCard from '../../../Cards/TodaysPlanCard/TodaysPlanCard';
import DefaultAvatar from '../../../../assets/icons/default-avatar.png';
import TechLogo from '../../../../assets/icons/tech-logo.svg';
import Button from '../../../UI/Button/Button';
import EditTopicForm from '../../../../components/Forms/EditTopicForm/EditTopicForm';
import CopyLiveSessionDetailForm from '../../../../components/Forms/CopyLiveSessionDetailForm/CopyLiveSessionDetailForm';
import EditLiveSessionDetailForm from '../../../Forms/EditLiveSessionDetailForm/EditLiveSessionDetailForm';
import GetJoinLinkPopupForm from '../../../../components/Forms/GetJoinLinkPopupForm/GetJoinLinkPopupForm';
import ConfirmationDialog from '../../../Popups/ConfirmationDialog/ConfirmationDialog';
import CloneQuizForm from '../../../Forms/CloneQuizForm/CloneQuizForm';
import CloneAssignmentForm from '../../../Forms/CloneAssignmentForm/CloneAssignmentForm';
import axios from 'axios';


class ModuleCurriculumTab extends React.Component {

    state = {
        topicsList: [],
        currentTopic: {},
        currentTopicDetails: {},
        selectedTopicPos: 0,

        quizResult: {},
        quizProblems: [],

        showEditAssignmentPopup: false,
        showEditQuizPopup: false,

        showContentLoader: true,
        showPopupLoader: false,
        showSessionPlanPopup: false,
        showCopyLiveSessionDetailPopup: false,
        showEditLiveSessionDetailPopup: false,
        showGetJoinLinkPopup: false,
        showLiveSessionLoader: false,
        liveSessionEndedManually: false,
        apiCallInProgress: false,
        show: true,
        overviewTab: { label: "Overview", type: "overview", currentTopic: { completed: 0, ongoing: 0, upcoming: 0 }, topicId: "overview" },
        overviewTabData: {},
        isOverviewTab: true,
        showEditTopicForm: false,

        batchCode: '',
        moduleName: '',
        programDetails: {
            name: 'Full Stack Developer Program',
            progress: 38,
            batchCode: 'FSR160421'
        },
        continueLearningData: {},
        todaysPlanData: {
            todaysPlan: {
                currentSessionData: [
                    { topicName: 'Test 1', type: 'live', topicId: 12342, scheduledTime: '10:00 PM', sessionEnded: false, }
                ], quizList: [], assignmentList: [], date: '06 June 2021'
            },
            instructor: { profilePic: DefaultAvatar, name: "Qaifi Khan" },
            module: { name: 'JavaScript', logo: TechLogo }
        },
        showDialogLoader: false,
        showConfirmationDialog: false,
        confirmationDialogMessage: 'Are you sure you want to delete this ',
        confirmationPrimaryButtonLabel: 'DELETE',
        confirmationSecondaryButtonLabel: 'CANCEL',

        showCloneQuizForm: false,
        showCloneAssignmentForm: false,
        deleteQuizProblem: false,
        quizProblemId: 0,
        showEditLiveSessionDropDown: false,
        showEnableButton: true,
    }

    getTopicDetails = (topicId) => {
        // console.log(' Get Topic Details - Curriculum Topic Clicked => ', topicId)

        let responseObj = null;
        ResourceAPIController.getCurriculumTopicDetails(topicId)
            .then(response => {
                responseObj = response.result;
                // console.log('[ Curriculum Page ] Topic Details Data => ', responseObj)
                this.setState({
                    currentTopic: responseObj.currentTopic[0],
                    currentTopicDetails: responseObj.currentTopicDetails,
                    showContentLoader: false, apiCallInProgress: false
                });

            })
            .catch(err => {
                console.log('[ Curriculum Page ] Topic Details error => ', err)
                this.setState({ showContentLoader: false, apiCallInProgress: false });
                if (IsObjectEmpty(err.error)) {
                    // LogParsingError('ParsingError: MainLayout: ' + err.toString(), EndPoints.SIGNED_IN_COMMON_DATA, responseObj);
                    return;
                }
                if (err.error.status === 400) {
                    this.props.onFailureDialogShow(err.error.message, 'OKAY');
                }
                if (err.error.status === 401) {
                    if (err.error.message === 'Invalid token.') {
                        this.props.showSessionExpiredDialog(true);
                    } else {
                        this.props.redirectToUnauthorized();
                    }
                }
                if (err.error.status === 404) {
                    this.props.redirectToNotFound();
                }
                if (err.error.status === 500) {
                    this.props.redirectToServerError();
                }
            });
    }

    getAssignmentDetails = (assignmentId) => {
        // console.log('Curriculum Assignment Clicked => ', assignmentId)
        let responseObj = null;
        ResourceAPIController.getCurriculumAssignmentDetails(assignmentId)
            .then(response => {
                responseObj = response.result;
                // console.log('[ Curriculum Page ] Assignment Page Data => ', responseObj)

                this.setState({
                    // currentTopic: responseObj.assignmentDetails,
                    currentTopicDetails: responseObj,
                    showContentLoader: false, apiCallInProgress: false
                });
            })
            .catch(err => {
                console.log('[ Curriculum Page ] Assignment Page error => ', err)
                this.setState({ showContentLoader: false, apiCallInProgress: false });
                if (IsObjectEmpty(err.error)) {
                    // LogParsingError('ParsingError: MainLayout: ' + err.toString(), EndPoints.SIGNED_IN_COMMON_DATA, responseObj);
                    return;
                }
                if (err.error.status === 400) {
                    this.props.onFailureDialogShow(err.error.message, 'OKAY');
                }
                if (err.error.status === 401) {
                    if (err.error.message === 'Invalid token.') {
                        this.props.showSessionExpiredDialog(true);
                    } else {
                        this.props.redirectToUnauthorized();
                    }
                }
                if (err.error.status === 404) {
                    this.props.onFailureDialogShow(err.error.message, 'OKAY')
                }
                if (err.error.status === 500) {
                    this.props.redirectToServerError();
                }
            });
    }

    getQuizDetails = (quizId) => {
        // console.log('Curriculum Quiz Clicked => ', quizId)

        let responseObj = null;
        ResourceAPIController.getCurriculumQuizDetails(quizId)
            .then(response => {
                responseObj = response.result;
                Log('[ Curriculum Page ] Quiz Page Data => ', responseObj)

                this.setState({
                    // currentTopic: response.result.quizResult,
                    currentTopicDetails: response.result,
                    showContentLoader: false, apiCallInProgress: false
                });
            })
            .catch(err => {
                // console.log('[ Curriculum Page ] Quiz Page error => ', err)
                this.setState({ showContentLoader: false, apiCallInProgress: false });
                if (IsObjectEmpty(err.error)) {
                    // LogParsingError('ParsingError: MainLayout: ' + err.toString(), EndPoints.SIGNED_IN_COMMON_DATA, responseObj);
                    return;
                }
                if (err.error.status === 400) {
                    this.props.onFailureDialogShow(err.error.message, 'OKAY');
                }
                if (err.error.status === 401) {
                    if (err.error.message === 'Invalid token.') {
                        this.props.showSessionExpiredDialog(true);
                    } else {
                        this.props.redirectToUnauthorized();
                    }
                }
                if (err.error.status === 404) {
                    this.props.redirectToNotFound();
                }
                if (err.error.status === 500) {
                    this.props.redirectToServerError();
                }
            });
    }

    onTodaysPlanTopicClicked = (topicId) => {
        // alert(topicId);
        let topicPos = this.state.topicsList.findIndex(topic => topic.topicId === topicId);
        this.onTopicItemClick(topicPos);
    }


    onTopicItemClick = (topicPos) => {
        if (topicPos !== this.state.selectedTopicPos) {
            this.setState({ selectedTopicPos: topicPos, showContentLoader: false, showEnableButton: true });

            const type = this.state.topicsList[topicPos].type;
            const topicId = this.state.topicsList[topicPos].topicId;
            const updatedCurrentTopic = this.state.topicsList[topicPos];
            this.setState({ currentTopic: updatedCurrentTopic, showContentLoader: true, apiCallInProgress: true });

            if (type === 'topic') {
                this.setState({ isOverviewTab: false })
                this.getTopicDetails(topicId);
            } else if (type === 'assignment') {
                this.setState({ isOverviewTab: false })
                this.getAssignmentDetails(topicId);
            } else if (type === 'quiz') {
                this.setState({ isOverviewTab: false })
                this.getQuizDetails(topicId);
            }

            else if (type === 'overview') {
                this.setState({ isOverviewTab: true });
                this.getCurriculumOverviewData();
            }
            const batchCode = !IsStringEmpty(this.props.match.params.batchCode)
                ? this.props.match.params.batchCode
                : !IsStringEmpty(this.props.activeProgramBatchCode)
                    ? this.props.activeProgramBatchCode : '';
            // props.moduleCurriculum ? RouteEndPoints.PROGRAMS_PAGE + '/' + props.batchCode + '/modules/' + props.breadCrumb + '/curriculum' 

            type === 'overview' ? this.props.history.push(RouteEndPoints.PROGRAMS_PAGE + '/' + batchCode + '/modules/' + encodeURIComponent(this.props.match.params.moduleName) + '/curriculum/' + type)
                : this.props.history.push(RouteEndPoints.PROGRAMS_PAGE + '/' + batchCode + '/modules/' + encodeURIComponent(this.props.match.params.moduleName) + '/curriculum/' + type + '/' + topicId);


        }
    }

    getPMCurriculumTopicsListData = (batchCode, moduleName) => {

        this.setState({ showContentLoader: true, })

        let responseObj = {}
        ResourceAPIController.getPMCurriculumTopicsListData(batchCode, moduleName)
            .then(response => {
                responseObj = response.result;
                // console.log('[Curriculum Page] Topics List Data => ', responseObj)


                const updatedTopicsList = responseObj.topicsList,
                    updatedCurrentTopic = responseObj.currentTopic[0],
                    updatedCurrentTopicDetails = responseObj.currentTopicDetails;

                let pos = '';
                if (!IsListEmpty(updatedTopicsList)) {
                    pos = updatedTopicsList.findIndex(topic => topic.topicId === updatedCurrentTopic.topicId && topic.type === updatedCurrentTopic.type);
                }
                this.setState({
                    topicsList: updatedTopicsList,
                    currentTopic: updatedCurrentTopic,
                    currentTopicDetails: updatedCurrentTopicDetails,
                    selectedTopicPos: pos,
                    showContentLoader: false
                });
            })
            .catch(err => {
                // console.log('[Curriculum Page] Topics List error => ', err)
                this.setState({ showContentLoader: false });
                if (IsObjectEmpty(err.error)) {
                    // LogParsingError('ParsingError: MainLayout: ' + err.toString(), EndPoints.SIGNED_IN_COMMON_DATA, responseObj);
                    return;
                }
                if (err.error.status === 400) {
                    this.props.onFailureDialogShow(err.error.message, 'OKAY');
                }
                if (err.error.status === 401) {
                    this.props.redirectToUnauthorized();
                }
                if (err.error.status === 404) {
                    this.props.redirectToNotFound();
                }
                if (err.error.status === 500) {
                    this.props.redirectToServerError();
                }
            });
    }


    getCurriculumCompleteQuizDetails = (quizId) => {
        this.setState({ showContentLoader: true });

        let responseObj = null;
        ResourceAPIController.getCurriculumCompleteQuizDetails(quizId)
            .then(response => {
                responseObj = response.result;
                // console.log('Modules Page Complete quiz Details Data => ', responseObj)

                const updatedCurrentTopic = responseObj.quizData.quizResult,
                    updatedTopicsList = responseObj.topicsList;

                const topicPos = updatedTopicsList.findIndex(topicItem => (
                    topicItem.topicId === updatedCurrentTopic.topicId && topicItem.type === updatedCurrentTopic.type
                ));

                this.setState({
                    selectedTopicPos: topicPos,
                    topicsList: updatedTopicsList,
                    currentTopic: updatedCurrentTopic,
                    currentTopicDetails: responseObj.quizData,
                    showContentLoader: false
                });

            })
            .catch(err => {
                console.log('Modules Page Listing quiz error => ', err)
                this.setState({ showContentLoader: false });
                if (IsObjectEmpty(err.error)) {
                    // LogParsingError('ParsingError: MainLayout: ' + err.toString(), EndPoints.SIGNED_IN_COMMON_DATA, responseObj);
                    return;
                }
                if (err.error.status === 400) {
                    this.props.onFailureDialogShow(err.error.message, 'OKAY');
                }
                if (err.error.status === 401) {
                    if (err.error.message === 'Invalid token.') {
                        this.props.showSessionExpiredDialog(true);
                    } else {
                        this.props.redirectToUnauthorized();
                    }
                }
                if (err.error.status === 404) {
                    this.props.redirectToNotFound();
                }
                if (err.error.status === 500) {
                    this.props.redirectToServerError();
                }
            });
    }

    getCurriculumCompleteAssignmentDetails = (assignmentId) => {
        this.setState({ showContentLoader: true });

        let responseObj = null;
        ResourceAPIController.getCurriculumCompleteAssignmentDetails(assignmentId)
            .then(response => {
                responseObj = response.result;
                // console.log('Modules Page Complete Assignment Details Data => ', responseObj)

                const updatedCurrentTopic = responseObj.assignmentData.assignmentDetails,
                    updatedTopicsList = responseObj.topicsList;

                const topicPos = updatedTopicsList.findIndex(topicItem => (
                    topicItem.topicId === updatedCurrentTopic.topicId && topicItem.type === updatedCurrentTopic.type
                ));

                this.setState({
                    selectedTopicPos: topicPos,
                    topicsList: responseObj.topicsList,
                    currentTopic: responseObj.assignmentData.assignmentDetails,
                    currentTopicDetails: responseObj.assignmentData,
                    showContentLoader: false
                });

            })
            .catch(err => {
                console.log('Modules Page Listing Assignment error => ', err)
                this.setState({ showContentLoader: false });
                if (IsObjectEmpty(err.error)) {
                    // LogParsingError('ParsingError: MainLayout: ' + err.toString(), EndPoints.SIGNED_IN_COMMON_DATA, responseObj);
                    return;
                }
                if (err.error.status === 400) {
                    this.props.onFailureDialogShow(err.error.message, 'OKAY');
                }
                if (err.error.status === 401) {
                    if (err.error.message === 'Invalid token.') {
                        this.props.showSessionExpiredDialog(true);
                    } else {
                        this.props.redirectToUnauthorized();
                    }
                }
                if (err.error.status === 404) {
                    this.props.redirectToNotFound();
                }
                if (err.error.status === 500) {
                    this.props.redirectToServerError();
                }
            });
    }

    getPMCurriculumCompleteTopicDetails = (batchCode, moduleName, topicId) => {
        this.setState({ showContentLoader: true });

        let responseObj = null;
        ResourceAPIController.getPMCurriculumCompleteTopicDetails(batchCode, moduleName, topicId)
            .then(response => {
                responseObj = response.result;
                // console.log('Modules Page Complete Topic Details Data => ', responseObj)

                const updatedTopicsList = responseObj.topicsList,
                    updatedCurrentTopic = responseObj.currentTopic[0],
                    updatedCurrentTopicDetails = responseObj.currentTopicDetails;

                const topicPos = updatedTopicsList.findIndex(topicItem => (
                    topicItem.topicId === updatedCurrentTopic.topicId && topicItem.type === updatedCurrentTopic.type
                ));

                this.setState({
                    selectedTopicPos: topicPos,
                    topicsList: updatedTopicsList,
                    currentTopic: updatedCurrentTopic,
                    currentTopicDetails: updatedCurrentTopicDetails,
                    showContentLoader: false
                });
            })
            .catch(err => {
                console.log('Modules Page Listing error => ', err)
                this.setState({ showContentLoader: false });
                if (IsObjectEmpty(err.error)) {
                    // LogParsingError('ParsingError: MainLayout: ' + err.toString(), EndPoints.SIGNED_IN_COMMON_DATA, responseObj);
                    return;
                }
                if (err.error.status === 400) {
                    this.props.onFailureDialogShow(err.error.message, 'OKAY');
                }
                if (err.error.status === 401) {
                    if (err.error.message === 'Invalid token.') {
                        this.props.showSessionExpiredDialog(true);
                    } else {
                        this.props.redirectToUnauthorized();
                    }
                }
                if (err.error.status === 404) {
                    this.props.redirectToNotFound();
                }
                if (err.error.status === 500) {
                    this.props.redirectToServerError();
                }
            });
    }

    logDataOnFirebase = (action) => {
        const email = GetFromLocalStorage(Constants.KEY_EMAIL),
            username = GetFromLocalStorage(Constants.KEY_USERNAME),
            currentTopic = { ...this.state.currentTopicDetails };

        const liveSession = { ...currentTopic.liveSessionList[0] };

        let data = {
            userType: "Program Manager",
            username: username,
            email: email,
            dateTime: getFullDateTime(new Date()),
            action: action,
            topicName: currentTopic.title,
            scheduledDateTime: currentTopic.scheduleDateTime.join(", "),
            moduleName: currentTopic.moduleName,
            batchCode: this.state.batchCode,
            pageURL: window.location.pathname,
            sessionId: liveSession.liveSessionId,
            sessionEnded: liveSession.sessionEnded,
            zoomAccount: liveSession.zoomAccount,
            meetingID: liveSession.meetId,
            sessionStartTime: liveSession.startTime
        }
        // console.log("Data Firebase Log : ", data)
        axios.post('https://classroom-start-live-sessions-default-rtdb.asia-southeast1.firebasedatabase.app/start-live-sessions-tracking.json', data);
    }


    startLiveSession = (liveSessionId, liveSessionURL, startedBy) => {
        // console.log("Start Live Session clicked! " + liveSessionId);
        // if (!IsStringEmpty(liveSessionURL)) {
        //     window.open(liveSessionURL, '_blank');
        // } else {
        this.setState({ showLiveSessionLoader: true });
        this.logDataOnFirebase('Initiated');
        ResourceAPIController.startInstructorLiveSession(liveSessionId, startedBy)
            .then(response => {

                this.logDataOnFirebase('Started');
                // console.log('startInstructorLiveSession Data => ', response.result)

                const liveSessionURL = response.result;
                this.setState({ showLiveSessionLoader: false });

                window.open(liveSessionURL, '_blank');

            })
            .catch(err => {
                this.logDataOnFirebase('Failed');
                console.log('startInstructorLiveSession error => ', err)
                this.setState({ showContentLoader: false });
                if (IsObjectEmpty(err.error)) {
                    // LogParsingError('ParsingError: MainLayout: ' + err.toString(), EndPoints.SIGNED_IN_COMMON_DATA, responseObj);
                    return;
                }
                if (err.error.status === 400) {
                    this.props.onFailureDialogShow(err.error.message, 'OKAY');
                }
                if (err.error.status === 401) {
                    if (err.error.message === 'Invalid token.') {
                        this.props.showSessionExpiredDialog(true);
                    } else {
                        this.props.redirectToUnauthorized();
                    }
                }
                if (err.error.status === 404) {
                    this.props.redirectToNotFound();
                }
                if (err.error.status === 500) {
                    this.props.redirectToServerError();
                }
            });
        // }

    }

    endLiveSession = (liveSessionId) => {
        // console.log("End Live Session clicked! " + liveSessionId);

        this.setState({ showLiveSessionLoader: true });
        ResourceAPIController.endInstructorLiveSession(liveSessionId)
            .then(response => {

                this.setState({ showLiveSessionLoader: false, liveSessionEndedManually: true });
                this.props.onSuccessDialogShow('Live Session has ended successfully.', 'DONE');
            })
            .catch(err => {
                console.log('END InstructorLiveSession error => ', err)
                this.setState({ showContentLoader: false });
                if (IsObjectEmpty(err.error)) {
                    // LogParsingError('ParsingError: MainLayout: ' + err.toString(), EndPoints.SIGNED_IN_COMMON_DATA, responseObj);
                    return;
                }
                if (err.error.status === 400) {
                    this.props.onFailureDialogShow(err.error.message, 'OKAY');
                }
                if (err.error.status === 401) {
                    if (err.error.message === 'Invalid token.') {
                        this.props.showSessionExpiredDialog(true);
                    } else {
                        this.props.redirectToUnauthorized();
                    }
                }
                if (err.error.status === 404) {
                    this.props.redirectToNotFound();
                }
                if (err.error.status === 500) {
                    this.props.redirectToServerError();
                }
            });

    }

    showEditAssignmentPopup = () => {
        this.setState({ showEditAssignmentPopup: true });
    }

    closePopup = () => {
        this.setState({ showEditQuizPopup: false, showEditAssignmentPopup: false, showSessionPlanPopup: false, showCopyLiveSessionDetailPopup: false, showEditLiveSessionDetailPopup: false, showEditTopicForm: false, showCloneQuizForm: false, showCloneAssignmentForm: false, showGetJoinLinkPopup: false });
    }
    showEditQuizPopup = () => {
        this.setState({ showEditQuizPopup: true });
    }

    showSessionPlanPopup = () => {
        this.setState({ showSessionPlanPopup: true });
    }
    showCopyLiveSessionDetailPopup = () => {
        this.setState({ showCopyLiveSessionDetailPopup: true, showEditLiveSessionDropDown: false });
    }
    showEditLiveSessionDetailPopup = () => {
        this.setState({ showEditLiveSessionDetailPopup: true, showEditLiveSessionDropDown: false });
    }
    showGetJoinLinkPopup = () => {
        this.setState({ showGetJoinLinkPopup: true, showEditLiveSessionDropDown: false });
    }
    editLiveSessionClick = () => {
        this.setState({ showEditLiveSessionDropDown: !this.state.showEditLiveSessionDropDown })
    }
    cloneQuiz = (quizId, quizData) => {
        this.setState({ showPopupLoader: true });

        let responseObj = null;
        ResourceAPIController.cloneQuiz(quizId, quizData)
            .then(response => {
                responseObj = response.result;
                this.setState({ showPopupLoader: false, showCloneQuizForm: false });
                this.props.onSuccessDialogShow('Quiz cloned successfully.', 'OKAY');

            })
            .catch(err => {
                console.log('Clone quiz error => ', err)
                this.setState({ showPopupLoader: false, showCloneQuizForm: false });
                if (err.error.status === 401) {
                    if (err.error.message === 'Invalid token.') {
                        this.props.showSessionExpiredDialog(true);
                    } else {
                        this.props.redirectToUnauthorized();
                    }
                } else {
                    this.props.onFailureDialogShow(err.error.message, 'OKAY');
                }
            });
    }

    cloneAssignment = (assignmentId, assignmentData) => {
        this.setState({ showPopupLoader: true });

        let responseObj = null;
        ResourceAPIController.cloneAssignment(assignmentId, assignmentData)
            .then(response => {
                responseObj = response.result;
                this.setState({ showPopupLoader: false, showCloneAssignmentForm: false });
                this.props.onSuccessDialogShow('Assignment cloned successfully.', 'OKAY');

            })
            .catch(err => {
                console.log('Clone assignment Details error => ', err)
                this.setState({ showPopupLoader: false, showCloneAssignmentForm: false });
                if (err.error.status === 401) {
                    if (err.error.message === 'Invalid token.') {
                        this.props.showSessionExpiredDialog(true);
                    } else {
                        this.props.redirectToUnauthorized();
                    }
                } else {
                    this.props.onFailureDialogShow(err.error.message, 'OKAY');
                }
            });
    }

    editQuizDetails = (quizId, quizData) => {
        this.setState({ showPopupLoader: true });

        let responseObj = null;
        ResourceAPIController.editQuizDetails(quizId, quizData)
            .then(response => {
                responseObj = response.result;
                // console.log('Edit quiz Details Data => ', responseObj)

                this.props.onSuccessDialogShow('Quiz updated successfully.', 'OKAY');

                let updatedCurrentTopicDetails = { ...this.state.currentTopicDetails };
                let updatedQuizDetails = updatedCurrentTopicDetails.quizResult;

                updatedQuizDetails.title = quizData.name;
                updatedQuizDetails.passingPercentage = quizData.passing_percentage;
                updatedQuizDetails.passingScore = updatedQuizDetails.totalScore * quizData.passing_percentage / 100;
                updatedQuizDetails.startDate = quizData.schedule_date;
                updatedQuizDetails.startTime = quizData.schedule_time;
                updatedQuizDetails.dueDate = quizData.due_date;
                updatedQuizDetails.dueTime = quizData.due_time;
                updatedQuizDetails.timeLimit = quizData.timer;
                updatedCurrentTopicDetails.quizResult = updatedQuizDetails;

                let updatedCurrentTopic = { ...this.state.currentTopic };
                updatedCurrentTopic.title = quizData.name;

                this.setState({
                    showPopupLoader: false, showEditQuizPopup: false,
                    currentTopic: updatedCurrentTopic,
                    currentTopicDetails: updatedCurrentTopicDetails
                });

            })
            .catch(err => {
                console.log('Edit quiz Details error => ', err)
                this.setState({ showPopupLoader: false, showEditQuizPopup: false });
                if (IsObjectEmpty(err.error)) {
                    // LogParsingError('ParsingError: MainLayout: ' + err.toString(), EndPoints.SIGNED_IN_COMMON_DATA, responseObj);
                    return;
                }
                if (err.error.status === 400) {
                    this.props.onFailureDialogShow(err.error.message, 'OKAY');
                }
                if (err.error.status === 401) {
                    if (err.error.message === 'Invalid token.') {
                        this.props.showSessionExpiredDialog(true);
                    } else {
                        this.props.redirectToUnauthorized();
                    }
                }
                if (err.error.status === 404) {
                    this.props.redirectToNotFound();
                }
                if (err.error.status === 500) {
                    this.props.redirectToServerError();
                }
            });
    }

    editAssignmentDetails = (assignmentId, assignmentData) => {
        this.setState({ showPopupLoader: true });

        let responseObj = null;
        ResourceAPIController.editAssignmentDetails(assignmentId, assignmentData)
            .then(response => {
                responseObj = response.result;
                // Log('Edit Assignment Details Data => ', responseObj)

                this.props.onSuccessDialogShow('Assignment updated successfully.', 'OKAY');

                const totalScore = this.state.currentTopicDetails.assignmentDetails.totalScore;

                const passingScore = parseInt(assignmentData.passing_percentage, 10) / 100 * totalScore;

                let updatedCurrentTopicDetails = { ...this.state.currentTopicDetails };
                let updatedAssignmentDetails = { ...this.state.currentTopicDetails.assignmentDetails }
                updatedAssignmentDetails.title = assignmentData.name;
                updatedAssignmentDetails.passingScore = passingScore;
                updatedAssignmentDetails.scheduleDate = assignmentData.schedule_date;
                updatedAssignmentDetails.scheduleTime = assignmentData.schedule_time;
                updatedAssignmentDetails.dueDate = assignmentData.due_date;
                updatedAssignmentDetails.dueTime = assignmentData.due_time;
                updatedCurrentTopicDetails.assignmentDetails = updatedAssignmentDetails;

                let updatedCurrentTopic = { ...this.state.currentTopic };
                updatedCurrentTopic.title = assignmentData.name;

                this.setState({
                    showPopupLoader: false, showEditAssignmentPopup: false, currentTopic: updatedCurrentTopic,
                    currentTopicDetails: updatedCurrentTopicDetails
                });

                this.getAssignmentDetails(assignmentId);
            })
            .catch(err => {
                console.log('Edit Assignment Details error => ', err)
                this.setState({ showPopupLoader: false, showEditAssignmentPopup: false });
                if (IsObjectEmpty(err.error)) {
                    // LogParsingError('ParsingError: MainLayout: ' + err.toString(), EndPoints.SIGNED_IN_COMMON_DATA, responseObj);
                    return;
                }
                if (err.error.status === 400) {
                    this.props.onFailureDialogShow(err.error.message, 'OKAY');
                }
                if (err.error.status === 401) {
                    if (err.error.message === 'Invalid token.') {
                        this.props.showSessionExpiredDialog(true);
                    } else {
                        this.props.redirectToUnauthorized();
                    }
                }
                if (err.error.status === 404) {
                    this.props.redirectToNotFound();
                }
                if (err.error.status === 500) {
                    this.props.redirectToServerError();
                }
            });
    }

    updateSessionPlanData = (sessionPlanData) => {
        this.setState({ showPopupLoader: true });

        let responseObj = null;
        ResourceAPIController.updateSessionPlanData(this.state.currentTopic.topicId, sessionPlanData)
            .then(response => {
                responseObj = response.result;
                // console.log('Edit Session Plan Details Data => ', responseObj)

                this.props.onSuccessDialogShow('Session plan updated successfully.', 'OKAY');

                let updatedCurrentTopicDetails = { ...this.state.currentTopicDetails };
                updatedCurrentTopicDetails.description = sessionPlanData.description;
                updatedCurrentTopicDetails.sessionTopics = sessionPlanData.sub_topics;
                updatedCurrentTopicDetails.scheduleDate = parseDateWithWeekDay(sessionPlanData.schedule_date);
                updatedCurrentTopicDetails.scheduleDateTime = [sessionPlanData.schedule_date, sessionPlanData.schedule_time];

                // schedule_date: "2021-04-12"
                // schedule_time: "19:30"

                let updatedCurrentTopic = { ...this.state.currentTopic };
                updatedCurrentTopic.date = parseDateWithWeekDay(sessionPlanData.schedule_date);


                this.setState({
                    showPopupLoader: false, showSessionPlanPopup: false, currentTopic: updatedCurrentTopic,
                    currentTopicDetails: updatedCurrentTopicDetails
                });

                this.getCurriculumPageData();
            })
            .catch(err => {
                console.log('Edit Session Plan Details error => ', err)
                this.setState({ showPopupLoader: false, showSessionPlanPopup: false });
                if (IsObjectEmpty(err.error)) {
                    // LogParsingError('ParsingError: MainLayout: ' + err.toString(), EndPoints.SIGNED_IN_COMMON_DATA, responseObj);
                    return;
                }
                if (err.error.status === 400) {
                    this.props.onFailureDialogShow(err.error.message, 'OKAY');
                }
                if (err.error.status === 401) {
                    if (err.error.message === 'Invalid token.') {
                        this.props.showSessionExpiredDialog(true);
                    } else {
                        this.props.redirectToUnauthorized();
                    }
                }
                if (err.error.status === 404) {
                    this.props.redirectToNotFound();
                }
                if (err.error.status === 500) {
                    this.props.redirectToServerError();
                }
            });
    }

    onDeleteSubtopicClicked = (subtopicId) => {

        ResourceAPIController.deleteSubtopic(subtopicId)
            .then(response => {
                // Log('Delete Subtopic Data => ', response.result);

                let updatedCurrentTopicDetails = { ...this.state.currentTopicDetails };
                let updatedSubtopicsList = [...updatedCurrentTopicDetails.sessionTopics];

                let index = updatedSubtopicsList.findIndex(topic => parseInt(topic.id, 10) === parseInt(subtopicId, 10));
                if (index !== -1) {
                    updatedSubtopicsList.splice(index, 1);
                }

                updatedCurrentTopicDetails.sessionTopics = updatedSubtopicsList;

                this.setState({ currentTopicDetails: updatedCurrentTopicDetails });
            })
            .catch(err => {
                console.log('Delete Subtopic error => ', err)
                this.setState({ showPopupLoader: false, showSessionPlanPopup: false });
                if (IsObjectEmpty(err.error)) {
                    // LogParsingError('ParsingError: MainLayout: ' + err.toString(), EndPoints.SIGNED_IN_COMMON_DATA, responseObj);
                    return;
                }
                if (err.error.status === 400) {
                    this.props.onFailureDialogShow(err.error.message, 'OKAY');
                }
                if (err.error.status === 401) {
                    if (err.error.message === 'Invalid token.') {
                        this.props.showSessionExpiredDialog(true);
                    } else {
                        this.props.redirectToUnauthorized();
                    }
                }
                if (err.error.status === 404) {
                    this.props.redirectToNotFound();
                }
                if (err.error.status === 500) {
                    this.props.redirectToServerError();
                }
            });
    }

    getCurriculumPageData = () => {
        const queryParams = !IsObjectEmpty(this.props.location) && !IsObjectEmpty(this.props.location.search) ?
            parseQueryParams(this.props.location.search) : {};

        const moduleName = !IsStringEmpty(this.props.match.params.moduleName)
            ? this.props.match.params.moduleName
            : ''

        const batchCode = !IsStringEmpty(this.props.match.params.batchCode)
            ? this.props.match.params.batchCode
            : ''

        this.setState({ batchCode: batchCode, moduleName: moduleName })

        const topicId = !IsStringEmpty(this.props.match.params.topicId) ? this.props.match.params.topicId : '';

        if (!IsStringEmpty(topicId) && !IsStringEmpty(moduleName) && this.state.apiCallInProgress === false) {


            let topicType = '';
            const locationObj = this.props.location;
            if (!IsObjectEmpty(locationObj) && !IsObjectEmpty(locationObj.state) && !IsStringEmpty(locationObj.state.type)) {
                topicType = locationObj.state.type;
            } else if (!IsObjectEmpty(queryParams) && !IsStringEmpty(queryParams.type)) {
                topicType = queryParams.type;
            } else if (!IsStringEmpty(this.props.match.params.topicType)) {
                topicType = this.props.match.params.topicType;
            }


            if (!IsStringEmpty(topicType)) {
                if (topicType === 'quiz') {
                    this.getCurriculumCompleteQuizDetails(topicId);
                } else if (topicType === 'assignment') {
                    this.getCurriculumCompleteAssignmentDetails(topicId);
                } else if (topicType === 'topic') {
                    this.getPMCurriculumCompleteTopicDetails(batchCode, moduleName, topicId);
                }
                else if (topicType === 'overview') {
                    this.getCurriculumOverviewData();
                }
            } else {
                this.getPMCurriculumTopicsListData(batchCode, moduleName);
            }
        } else if (!IsStringEmpty(moduleName) && this.state.apiCallInProgress === false) {
            this.getPMCurriculumTopicsListData(batchCode, moduleName);
        }
        // this.props.redirectToHome(false);
        // this.getCurriculumOverviewData();
    }

    isLearner = GetFromLocalStorage(Constants.KEY_IS_LEARNER) === 'true' ? true : false;

    getCurriculumOverviewData = () => {
        this.setState({ showPopupLoader: true });
        const moduleName = !IsStringEmpty(this.props.match.params.moduleName)
            ? this.props.match.params.moduleName
            : ''

        const batchCode = !IsStringEmpty(this.props.match.params.batchCode)
            ? this.props.match.params.batchCode
            : ''

        let responseObj = null;
        ResourceAPIController.getCurriculumOverviewData(batchCode, moduleName)
            .then(response => {
                responseObj = response.result
                this.setState({
                    overviewTabData: responseObj,
                    showContentLoader: false
                })
            })
            .catch(err => {
                console.log('Edit Session Plan Details error => ', err)
                this.setState({ showPopupLoader: false, showSessionPlanPopup: false });
                if (IsObjectEmpty(err.error)) {
                    // LogParsingError('ParsingError: MainLayout: ' + err.toString(), EndPoints.SIGNED_IN_COMMON_DATA, responseObj);
                    return;
                }
                if (err.error.status === 400) {
                    this.props.onFailureDialogShow(err.error.message, 'OKAY');
                }
                if (err.error.status === 401) {
                    if (err.error.message === 'Invalid token.') {
                        this.props.showSessionExpiredDialog(true);
                    } else {
                        this.props.redirectToUnauthorized();
                    }
                }
                if (err.error.status === 404) {
                    this.props.redirectToNotFound();
                }
                if (err.error.status === 500) {
                    this.props.redirectToServerError();
                }
            });
    }

    handleShowHide = () => {
        const updatedState = this.state.show;
        this.setState({ show: !updatedState });
    }

    showEditTopicForm = () => {
        this.setState({ showEditTopicForm: true });
    }

    showConfirmationDialog = (type) => {
        const message = `Are you sure you want to delete ${this.state.currentTopic.title} ?`;
        this.setState({ showConfirmationDialog: true, confirmationDialogMessage: message });
    }

    confirmationSecondaryButtonClick = () => {
        this.setState({ showConfirmationDialog: false, deleteQuizProblem: false, quizProblemId: -1 });
    }

    showQuizConfirmationDialog = (problemId, questionNumber) => {
        const message = 'Are you sure you want to delete Question ' + (questionNumber) + ' ?';
        this.setState({ showConfirmationDialog: true, confirmationDialogMessage: message, deleteQuizProblem: true, quizProblemId: problemId });
    }

    confirmationPrimaryButtonClicked = () => {

        if (this.state.deleteQuizProblem === true)
            this.deleteQuizProblem(this.state.quizProblemId);

        else if (this.state.currentTopic.type === 'topic')
            this.deleteTopic(this.state.currentTopic.topicId);

        else if (this.state.currentTopic.type === 'assignment')
            this.deleteAssignment(this.state.currentTopic.topicId);

        else if (this.state.currentTopic.type === 'quiz')
            this.deleteQuiz(this.state.currentTopic.topicId);
    }

    deleteQuizProblem = (problemId) => {
        this.setState({ showDialogLoader: true });
        ResourceAPIController.deleteQuizProblem(problemId)
            .then(response => {
                this.setState({ showConfirmationDialog: false, showDialogLoader: false, deleteQuizProblem: false, quizProblemId: -1, showContentLoader: true });
                this.getQuizDetails(this.state.currentTopic.topicId)
                this.props.onSuccessDialogShow('Quiz problem deleted successfully.', 'OKAY');
            })
            .catch(err => {
                // console.log('Edit Delete Curriculum Topic error => ', err)
                this.setState({ showPopupLoader: false, showSessionPlanPopup: false, showConfirmationDialog: false, showDialogLoader: false, deleteQuizProblem: false, quizProblemId: -1 });
                if (IsObjectEmpty(err.error)) {
                    return;
                }
                if (err.error.status === 400) {
                    this.props.onFailureDialogShow(err.error.message, 'OKAY');
                }
                if (err.error.status === 401) {
                    if (err.error.message === 'Invalid token.') {
                        this.props.showSessionExpiredDialog(true);
                    } else {
                        this.props.redirectToUnauthorized();
                    }
                }
                if (err.error.status === 404) {
                    this.props.redirectToNotFound();
                }
                if (err.error.status === 500) {
                    this.props.redirectToServerError();
                }
            });
    }

    deleteTopic = (topicId) => {
        this.setState({ showDialogLoader: true });
        ResourceAPIController.deleteCurriculumTopic(topicId)
            .then(response => {
                this.setState({ showConfirmationDialog: false, showDialogLoader: false });
                this.props.onSuccessDialogShow('Topic deleted successfully.', 'OKAY');
                this.props.history.push(RouteEndPoints.PROGRAMS_PAGE + '/' + this.state.batchCode + '/modules/' + encodeURIComponent(this.state.moduleName) + '/curriculum');
                // this.getCurriculumPageData();
                // this.getCurriculumOverviewData();
            })
            .catch(err => {
                // console.log('Edit Delete Curriculum Topic error => ', err)
                this.setState({ showPopupLoader: false, showSessionPlanPopup: false, showConfirmationDialog: false, showDialogLoader: false });
                if (IsObjectEmpty(err.error)) {
                    // LogParsingError('ParsingError: MainLayout: ' + err.toString(), EndPoints.SIGNED_IN_COMMON_DATA, responseObj);
                    return;
                }
                if (err.error.status === 400) {
                    this.props.onFailureDialogShow(err.error.message, 'OKAY');
                }
                if (err.error.status === 401) {
                    if (err.error.message === 'Invalid token.') {
                        this.props.showSessionExpiredDialog(true);
                    } else {
                        this.props.redirectToUnauthorized();
                    }
                }
                if (err.error.status === 404) {
                    this.props.redirectToNotFound();
                }
                if (err.error.status === 500) {
                    this.props.redirectToServerError();
                }
            });
    }

    deleteAssignment = (assignmentId) => {
        this.setState({ showDialogLoader: true });
        ResourceAPIController.deleteAssignment(assignmentId)
            .then(response => {
                this.setState({ showConfirmationDialog: false, showDialogLoader: false });
                this.props.onSuccessDialogShow('Assignment deleted successfully.', 'OKAY');
                this.props.history.push(RouteEndPoints.PROGRAMS_PAGE + '/' + this.state.batchCode + '/modules/' + encodeURIComponent(this.state.moduleName) + '/curriculum');
                // this.getCurriculumPageData();
                // this.getCurriculumOverviewData();
            })
            .catch(err => {
                // console.log('Edit Delete Assignment error => ', err)
                this.setState({ showPopupLoader: false, showSessionPlanPopup: false, showConfirmationDialog: false, showDialogLoader: false });
                if (IsObjectEmpty(err.error)) {
                    // LogParsingError('ParsingError: MainLayout: ' + err.toString(), EndPoints.SIGNED_IN_COMMON_DATA, responseObj);
                    return;
                }
                if (err.error.status === 400) {
                    this.props.onFailureDialogShow(err.error.message, 'OKAY');
                }
                if (err.error.status === 401) {
                    if (err.error.message === 'Invalid token.') {
                        this.props.showSessionExpiredDialog(true);
                    } else {
                        this.props.redirectToUnauthorized();
                    }
                }
                if (err.error.status === 404) {
                    this.props.redirectToNotFound();
                }
                if (err.error.status === 500) {
                    this.props.redirectToServerError();
                }
            });
    }

    deleteQuiz = (topicId) => {
        this.setState({ showDialogLoader: true });
        ResourceAPIController.deleteQuiz(topicId)
            .then(response => {
                this.setState({ showConfirmationDialog: false, showDialogLoader: false });
                this.props.onSuccessDialogShow('Quiz deleted successfully.', 'OKAY');
                this.props.history.push(RouteEndPoints.PROGRAMS_PAGE + '/' + this.state.batchCode + '/modules/' + encodeURIComponent(this.state.moduleName) + '/curriculum');
                // this.getCurriculumPageData();
                // this.getCurriculumOverviewData();
            })
            .catch(err => {
                // console.log('Edit Delete Curriculum Topic error => ', err)
                this.setState({ showPopupLoader: false, showSessionPlanPopup: false, showConfirmationDialog: false, showDialogLoader: false });
                if (IsObjectEmpty(err.error)) {
                    // LogParsingError('ParsingError: MainLayout: ' + err.toString(), EndPoints.SIGNED_IN_COMMON_DATA, responseObj);
                    return;
                }
                if (err.error.status === 400) {
                    this.props.onFailureDialogShow(err.error.message, 'OKAY');
                }
                if (err.error.status === 401) {
                    if (err.error.message === 'Invalid token.') {
                        this.props.showSessionExpiredDialog(true);
                    } else {
                        this.props.redirectToUnauthorized();
                    }
                }
                if (err.error.status === 404) {
                    this.props.redirectToNotFound();
                }
                if (err.error.status === 500) {
                    this.props.redirectToServerError();
                }
            });
    }

    updateTopicData = (sessionPlanData) => {
        this.setState({ showPopupLoader: true });

        ResourceAPIController.updateTopicData(this.state.currentTopic.topicId, sessionPlanData)
            .then(response => {
                // Log('Update Topic Details Details Data => ', response.result)

                this.props.onSuccessDialogShow('Topic updated successfully.', 'OKAY');

                let updatedCurrentTopicDetails = { ...this.state.currentTopicDetails };
                updatedCurrentTopicDetails.title = sessionPlanData.topic_name;
                updatedCurrentTopicDetails.scheduleDate = parseDateWithWeekDay(sessionPlanData.schedule_date);
                updatedCurrentTopicDetails.scheduleDateTime = [sessionPlanData.schedule_date, sessionPlanData.schedule_time];

                // schedule_date: "2021-04-12"
                // schedule_time: "19:30"

                let updatedCurrentTopic = { ...this.state.currentTopic };
                updatedCurrentTopic.date = parseDateWithWeekDay(sessionPlanData.schedule_date);
                updatedCurrentTopic.title = sessionPlanData.topic_name;

                this.setState({
                    showPopupLoader: false, showEditTopicForm: false, currentTopic: updatedCurrentTopic,
                    currentTopicDetails: updatedCurrentTopicDetails
                });

                this.getCurriculumPageData();
            })
            .catch(err => {
                console.log('Update Topic Data Details error => ', err)
                this.setState({ showPopupLoader: false, showSessionPlanPopup: false });
                if (IsObjectEmpty(err.error)) {
                    // LogParsingError('ParsingError: MainLayout: ' + err.toString(), EndPoints.SIGNED_IN_COMMON_DATA, responseObj);
                    return;
                }
                if (err.error.status === 400) {
                    this.props.onFailureDialogShow(err.error.message, 'OKAY');
                }
                if (err.error.status === 401) {
                    if (err.error.message === 'Invalid token.') {
                        this.props.showSessionExpiredDialog(true);
                    } else {
                        this.props.redirectToUnauthorized();
                    }
                }
                if (err.error.status === 404) {
                    this.props.redirectToNotFound();
                }
                if (err.error.status === 500) {
                    this.props.redirectToServerError();
                }
            });
    }

    showCloneQuizForm = () => {
        this.setState({ showCloneQuizForm: true });
    }

    showCloneAssignmentForm = () => {
        this.setState({ showCloneAssignmentForm: true });
    }

    onUploadSuccessful = () => {
        this.getCurriculumPageData();
    }

    componentDidMount() {
        this.props.setupProgramDetailsTopbar(true, true, true, true);
        if (this.isLearner === false) {
            if (!IsStringEmpty(this.props.activeModuleId) && this.props.activeModuleId !== undefined) {
                this.getCurriculumPageData();
            } else {
                this.setState({ currentSubmissionsList: [], showLoader: false });
            }
        }
        this.getCurriculumPageData();
    }

    onEnableLiveSessionButtonClicked = (pos) => {
        let updatedList = this.state.currentTopicDetails;
        updatedList.liveSessionList[pos].enableButton = true;
        this.setState({ currentTopicDetails: updatedList, showEnableButton: false })

    }

    componentDidUpdate(prevProps) {
        if (this.props.activeModuleId !== prevProps.activeModuleId && !this.isLearner) {
            if (!IsStringEmpty(this.props.activeModuleName) && prevProps.redirectToHomeStatus === false && this.props.redirectToHomeStatus === false) {
                this.getCurriculumPageData();
            }
        }
        if (prevProps.location.pathname !== this.props.location.pathname) {
            this.setState({ liveSessionEndedManually: false });
            this.getCurriculumPageData();
        }
    }

    render() {
        const liveSessionEnded =
            !IsObjectEmpty(this.state.currentTopicDetails) && !IsListEmpty(this.state.currentTopicDetails.liveSessionList)
                ? this.state.currentTopicDetails.liveSessionList[0].sessionEnded === true
                    || this.state.liveSessionEndedManually === true ? true : false
                : false;

        const overviewTab = <div>
            <h3 className={classes.Heading}>Overview</h3>
            <p className={classes.SubHeading}>Completed Units</p>
            <div className={classes.CardContainer}>
                <ProgressCard value={[this.state.overviewTabData.completedTopics, this.state.overviewTabData.totalTopics]} label="Topics" type="fraction" />
                <ProgressCard value={[this.state.overviewTabData.completedLiveSessions, this.state.overviewTabData.totalLiveSessions]} label="LIVE Sessions" type="fraction" />
                <ProgressCard value={[this.state.overviewTabData.completedQuizzes, this.state.overviewTabData.totalQuizzes]} label="Quizzes" type="fraction" />
                <ProgressCard value={[this.state.overviewTabData.completedAssignments, this.state.overviewTabData.totalAssignments]} label="Assignments" type="fraction" />
            </div>
            <h3 className={classes.SubHeading}>Today's Plan</h3>
            <TodaysPlanCard
                data={this.state.overviewTabData}
                batchCode={this.state.batchCode}
                showLiveSessionLoader={this.state.showLiveSessionLoader}
                liveSessionEndedManually={this.state.liveSessionEndedManually}
                startLiveSession={this.startLiveSession}
                endLiveSession={this.endLiveSession}
                onTodaysPlanTopicClicked={this.onTodaysPlanTopicClicked} />
        </div>

        return (
            <div className={[classes.CurriculumPageContainer, !this.state.show ? classes.FullWidth : null].join(' ')}>
                {this.isLearner ? <Redirect to={RouteEndPoints.UNAUTHORIZED_ERROR} /> : null}

                <AddMetaTags
                    url={window.location.pathname}
                    title={'Curriculum Page'}
                />

                <ProgramProgressTopbarPM
                    batchCode={this.state.batchCode}
                    name={this.state.moduleName}
                    progress={0}
                    hideProgress={true} />

                <ModuleDetailsSidebar
                    forOverviewPage={false}
                    heading={"Curriculum"}
                    batchCode={this.props.match.params.batchCode}
                    breadCrumb={this.props.match.params.moduleName}
                    logo={this.state.moduleLogo}
                    navigationItems={this.state.topicsList}
                    onNavigationItemClick={this.onTopicItemClick}
                    activeType={this.state.selectedTopicPos}
                    onBreadCrumbClick={this.onBreadCrumbClick}
                    enrolledPrograms={this.state.enrolledPrograms}
                    handleShowHide={this.handleShowHide}
                    show={this.state.show}
                    moduleCurriculum={true}
                />

                {
                    this.state.showConfirmationDialog
                        ? <ConfirmationDialog
                            showLoading={this.state.showDialogLoader}
                            show={this.state.showConfirmationDialog}
                            message={this.state.confirmationDialogMessage}
                            secondaryButtonLabel={this.state.confirmationSecondaryButtonLabel}
                            secondaryButtonClick={this.confirmationSecondaryButtonClick}
                            primaryButtonLabel={this.state.confirmationPrimaryButtonLabel}
                            primaryButtonClicked={this.confirmationPrimaryButtonClicked} />
                        : null
                }

                {
                    this.state.showEditAssignmentPopup
                        ? <EditAssignmentForm
                            forEdit={true}
                            data={this.state.currentTopicDetails.assignmentDetails}
                            closePopup={this.closePopup}
                            showLoader={this.state.showPopupLoader}
                            editAssignmentDetails={this.editAssignmentDetails}
                        />
                        : null

                }

                {
                    this.state.showEditTopicForm
                        ? <EditTopicForm
                            forEdit={false}
                            data={this.state.currentTopicDetails}
                            closePopup={this.closePopup}
                            showLoader={this.state.showPopupLoader}
                            liveSessionEnded={liveSessionEnded}
                            updateTopicData={this.updateTopicData}
                        />
                        : null

                }
                {
                    this.state.showCopyLiveSessionDetailPopup
                        ? <CopyLiveSessionDetailForm
                            onSuccessDialogShow={this.props.onSuccessDialogShow}
                            onFailureDialogShow={this.props.onFailureDialogShow}
                            forEdit={false}
                            data={this.state.currentTopicDetails}
                            closePopup={this.closePopup}
                            showLoader={this.state.showPopupLoader}
                            liveSessionEnded={liveSessionEnded}
                            updateTopicData={this.updateTopicData}
                        />
                        : null
                }
                {
                    this.state.showEditLiveSessionDetailPopup
                        ? <EditLiveSessionDetailForm
                            onSuccessDialogShow={this.props.onSuccessDialogShow}
                            onFailureDialogShow={this.props.onFailureDialogShow}
                            data={this.state.currentTopicDetails}
                            closePopup={this.closePopup}
                            showLoader={this.state.showPopupLoader}
                            getCurriculumPageData={this.getCurriculumPageData}
                        />
                        : null
                }
                {
                    this.state.showGetJoinLinkPopup
                        ? <GetJoinLinkPopupForm
                            onSuccessDialogShow={this.props.onSuccessDialogShow}
                            onFailureDialogShow={this.props.onFailureDialogShow}
                            forEdit={false}
                            data={this.state.currentTopicDetails}
                            closePopup={this.closePopup}
                            showLoader={this.state.showPopupLoader}
                            liveSessionEnded={liveSessionEnded}
                            updateTopicData={this.updateTopicData}
                        />
                        : null
                }

                {
                    this.state.showSessionPlanPopup
                        ? <SessionPlanForm
                            forEdit={false}
                            data={this.state.currentTopicDetails}
                            closePopup={this.closePopup}
                            showLoader={this.state.showPopupLoader}
                            liveSessionEnded={liveSessionEnded}
                            updateSessionPlanClicked={this.updateSessionPlanData}
                            onDeleteSubtopicClicked={this.onDeleteSubtopicClicked}
                        />
                        : null

                }

                {
                    this.state.showEditQuizPopup
                        ? <EditQuizForm
                            forEdit={true}
                            data={this.state.currentTopicDetails.quizResult}
                            closePopup={this.closePopup}
                            showLoader={this.state.showPopupLoader}
                            editQuizDetails={this.editQuizDetails}
                        />
                        : null
                }

                {
                    this.state.showCloneQuizForm
                        ? <CloneQuizForm
                            data={this.state.currentTopicDetails.quizResult}
                            closePopup={this.closePopup}
                            showLoader={this.state.showPopupLoader}
                            cloneQuiz={this.cloneQuiz}
                            showSessionExpiredDialog={this.props.showSessionExpiredDialog}
                            redirectToUnauthorized={this.props.redirectToUnauthorized}
                            onFailureDialogShow={this.props.onFailureDialogShow}
                        />
                        : null
                }

                {
                    this.state.showCloneAssignmentForm
                        ? <CloneAssignmentForm
                            data={this.state.currentTopicDetails.assignmentDetails}
                            closePopup={this.closePopup}
                            showLoader={this.state.showPopupLoader}
                            cloneAssignment={this.cloneAssignment}
                            showSessionExpiredDialog={this.props.showSessionExpiredDialog}
                            redirectToUnauthorized={this.props.redirectToUnauthorized}
                            onFailureDialogShow={this.props.onFailureDialogShow}
                        />
                        : null
                }

                {
                    this.state.showContentLoader
                        ? <div className={classes.LoaderContainer}>
                            <ShowLoader isLoading={true} />
                        </div>
                        : <div className={classes.CurriculumPageData}>
                            <h3 className={classes.CurriculumPageHeading}>
                                {!IsObjectEmpty(this.state.currentTopic) && this.state.currentTopic.type === "overview" ? null : !IsObjectEmpty(this.state.currentTopic) ? this.state.currentTopic.title : 'Loading...'}
                            </h3>
                            <p className={classes.Date}>
                                {!IsObjectEmpty(this.state.currentTopic) && this.state.currentTopic.type === "overview" ? null : !IsStringEmpty(this.state.currentTopic.date)
                                    ? this.state.currentTopic.date
                                    : ''}
                                {this.state.currentTopic.type === 'topic' &&
                                    <span>,  {!IsObjectEmpty(this.state.currentTopicDetails) ? this.state.currentTopicDetails.scheduleDateTime[1] : ''}</span>}
                            </p>

                            {this.state.isOverviewTab && !IsObjectEmpty(this.state.currentTopic) && this.state.currentTopic.type === "overview"
                                && overviewTab}

                            {
                                !IsObjectEmpty(this.state.currentTopic) && this.state.currentTopic.type === "topic"
                                    ? IsObjectEmpty(this.state.currentTopicDetails)
                                        ? <div className={classes.LoaderContainer}>
                                            <ShowLoader isLoading={true} />
                                        </div>
                                        : <div>
                                            <SessionPlanData
                                                topicData={this.state.currentTopicDetails}
                                                forInstructor={true}
                                                forProgramManager={true}
                                                editSessionPlanClicked={this.showSessionPlanPopup}
                                                copyLiveSessionDetailClicked={this.showCopyLiveSessionDetailPopup}
                                                editLiveSessionDetailClicked={this.showEditLiveSessionDetailPopup}
                                                getJoinLink={this.showGetJoinLinkPopup}
                                                showEditLiveSessionDropDown={this.state.showEditLiveSessionDropDown}
                                                editLiveSessionClick={this.editLiveSessionClick}
                                                showLiveSessionLoader={this.state.showLiveSessionLoader}
                                                startLiveSession={this.startLiveSession}
                                                endLiveSession={this.endLiveSession}
                                                editTopicClicked={this.showEditTopicForm}
                                                liveSessionEndedManually={this.state.liveSessionEndedManually}
                                                onUploadSuccessful={this.onUploadSuccessful}
                                                getTopicDetails={this.getTopicDetails}
                                                onSuccessDialogShow={this.props.onSuccessDialogShow}
                                                onFailureDialogShow={this.props.onFailureDialogShow}
                                                redirectToUnauthorized={this.props.redirectToUnauthorized}
                                                showSessionExpiredDialog={this.props.showSessionExpiredDialog}
                                                redirectToNotFound={this.props.redirectToNotFound}
                                                redirectToServerError={this.props.redirectToServerError}
                                                onEnableLiveSessionButtonClicked={this.onEnableLiveSessionButtonClicked}
                                                showEnableButton={this.state.showEnableButton}
                                            />
                                            <div className={classes.DeleteButton}>
                                                <Button
                                                    label='DELETE TOPIC'
                                                    styleclass="DeleteButton"
                                                    fontSize="0.875em"
                                                    clicked={() => this.showConfirmationDialog('Topic')}
                                                    disabled={false}
                                                    margin="1em auto 0 auto"
                                                    padding="8px 32px"
                                                />
                                            </div>
                                        </div>
                                    : null
                            }

                            {
                                !IsObjectEmpty(this.state.currentTopic) && this.state.currentTopic.type === "quiz"
                                    ? IsObjectEmpty(this.state.currentTopicDetails)
                                        ? <div className={classes.LoaderContainer}>
                                            <ShowLoader isLoading={true} />
                                        </div>
                                        :
                                        <div>
                                            <CurriculumQuizContent
                                                forPMPage={true}
                                                batchCode={this.state.batchCode}
                                                moduleName={this.state.moduleName}
                                                topicData={this.state.currentTopic}
                                                data={this.state.currentTopicDetails}
                                                showEditQuizPopup={this.showEditQuizPopup}
                                                getQuizDetails={this.getQuizDetails}
                                                showConfirmationDialog={this.showQuizConfirmationDialog}
                                                onFailureDialogShow={this.props.onFailureDialogShow}
                                                onSuccessDialogShow={this.props.onSuccessDialogShow}
                                                redirectToUnauthorized={this.props.redirectToUnauthorized}
                                                showSessionExpiredDialog={this.props.showSessionExpiredDialog}
                                                redirectToNotFound={this.props.redirectToNotFound}
                                                redirectToServerError={this.props.redirectToServerError} />
                                            <div className={classes.DeleteButton}>
                                                <Button
                                                    label='DELETE QUIZ'
                                                    styleclass="DeleteButton"
                                                    fontSize="0.875em"
                                                    clicked={() => this.showConfirmationDialog('Quiz')}
                                                    disabled={false}
                                                    margin="1em 1.5em 0 auto"
                                                    padding="8px 32px"
                                                />

                                                <Button
                                                    label='CLONE QUIZ'
                                                    styleclass='BlueBorderButton'
                                                    fontSize="0.875em"
                                                    clicked={this.showCloneQuizForm}
                                                    disabled={false}
                                                    margin="1em auto 0 auto"
                                                    padding="8px 32px"
                                                />
                                            </div>
                                        </div>
                                    : null
                            }

                            {
                                !IsObjectEmpty(this.state.currentTopic) && this.state.currentTopic.type === "assignment"
                                    ? IsObjectEmpty(this.state.currentTopicDetails)
                                        ? <div className={classes.LoaderContainer}>
                                            <ShowLoader isLoading={true} />
                                        </div>
                                        :
                                        <div>
                                            <CurriculumAssignmentContent
                                                forPMPage={true}
                                                topicData={this.state.currentTopic}
                                                batchCode={this.state.batchCode}
                                                moduleName={this.state.moduleName}
                                                data={this.state.currentTopicDetails}
                                                showEditAssignmentPopup={this.showEditAssignmentPopup}
                                                updateAssignmentDetails={this.getAssignmentDetails}
                                                onFailureDialogShow={this.props.onFailureDialogShow}
                                                onSuccessDialogShow={this.props.onSuccessDialogShow}
                                                redirectToUnauthorized={this.props.redirectToUnauthorized}
                                                showSessionExpiredDialog={this.props.showSessionExpiredDialog}
                                                redirectToNotFound={this.props.redirectToNotFound}
                                                redirectToServerError={this.props.redirectToServerError} />
                                            <div className={classes.DeleteButton}>
                                                <Button
                                                    label='DELETE ASSIGNMENT'
                                                    styleclass="DeleteButton"
                                                    fontSize="0.875em"
                                                    clicked={() => this.showConfirmationDialog('Assignment')}
                                                    disabled={false}
                                                    margin="1em 1.5em 0 auto"
                                                    padding="8px 32px"
                                                />

                                                <Button
                                                    label='CLONE ASSIGNMENT'
                                                    styleclass='BlueBorderButton'
                                                    fontSize="0.875em"
                                                    clicked={this.showCloneAssignmentForm}
                                                    disabled={false}
                                                    margin="1em auto 0 auto"
                                                    padding="8px 32px"
                                                />
                                            </div>
                                        </div>
                                    : null
                            }
                        </div>
                }
            </div>
        );
    }
}


const mapStateToProps = state => {
    return {
        activeProgramBatchCode: state.activeProgramBatchCode,
        activeModuleName: state.activeModuleName,
        activeModuleId: state.activeModuleId,

        showSuccessDialog: state.showSuccessDialog,
        successDialogMessage: state.successDialogMessage,
        successDialogButtonLabel: state.successDialogButtonLabel,
        showFailureDialog: state.showFailureDialog,
        failureDialogMessage: state.failureDialogMessage,
        failureDialogButtonLabel: state.failureDialogButtonLabel,
        somethingWentWrong: state.somethingWentWrong,
        notFound: state.notFound,
        unauthorized: state.unauthorized,
    }
}

const mapDisptachToProps = dispatch => {
    return {
        setTopbarTheme: () => dispatch(actionCreators.setTopbarTheme('Light')),

        setupProgramDetailsTopbar: (showTopbar, showProgramProgress, showModuleProgress, hideTopBar) => dispatch(actionCreators.setupProgramDetailsTopbar(showTopbar, showProgramProgress, showModuleProgress, hideTopBar)),

        onFailureDialogShow: (msg, btnLabel) => dispatch(actionCreators.onFailureDialogShow(msg, btnLabel)),
        onFailureDialogHide: () => dispatch(actionCreators.onFailureDialogHide()),
        onSuccessDialogShow: (msg, btnLabel) => dispatch(actionCreators.onSuccessDialogShow(msg, btnLabel)),
        onSuccessDialogHide: () => dispatch(actionCreators.onSuccessDialogHide()),

        redirectToUnauthorized: () => dispatch(actionCreators.redirectToUnauthorized()),
        redirectToNotFound: () => dispatch(actionCreators.redirectToNotFound()),
        redirectToServerError: () => dispatch(actionCreators.redirectToServerError()),
        showSessionExpiredDialog: (show) => dispatch(actionCreators.showSessionExpiredDialog(show))

    }
}

export default connect(mapStateToProps, mapDisptachToProps)(withRouter(ModuleCurriculumTab));